import { ChatKeyValueEntry } from 'sdk';

export const getFormValues = (form: HTMLFormElement): ChatKeyValueEntry[] => {
	const prechatValues: ChatKeyValueEntry[] = [];
	const fields = form.elements;

	for (let i = 0; i < fields.length; i++) {
		const field = fields[i] as HTMLInputElement;
		if (field.name) {
			const alreadyCreatedEntry = prechatValues.find(({ key }) => field.name === key);
			if (alreadyCreatedEntry) {
				alreadyCreatedEntry.value += `|${field.value}`;
			} else {
				prechatValues.push({ key: field.name, value: field.value });
			}
		}
	}
	return prechatValues;
};
